import CandidatesEmptyState from './CandidatesEmptyState.component';

export default CandidatesEmptyState;
